/* eslint-disable prettier/prettier */
import React, { useCallback } from 'react';

import useOutsideClick from 'hooks/useOutsideClick';

import { Container, Items, Item } from './styles';

interface UserType {
  key: string;
  value: string;
}

interface Props {
  show: boolean;
  value: any;
  userType?: UserType[];
  selectRef: React.RefObject<HTMLDivElement>;
  onChange: (value: string) => void;
  onClose: () => void;
}

interface MakeItemProps {
  className: string;
  text: string;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
}

const MakeItem = ({ text, ...rest }: MakeItemProps) => <Item {...rest}>{text}</Item>;

const SelectUserType = ({ show, userType, selectRef, value, onChange, onClose }: Props) => {
  useOutsideClick(selectRef, onClose);

  const isUserTypeActive = useCallback((item: UserType) => item === value.key, [value]);

  const handleItemClick = (id: string) => {
    if (id !== value) {
      onChange(id);
    }
    onClose();
  };

  const makeUserType = (userTypeField: UserType) => userTypeField.value;

  return show ? (
    <Container>
      <Items>
        { 
            userType ?
            userType.slice(1).map((t) => (
                <MakeItem
                key={t.key}
                className={isUserTypeActive(t) ? 'active' : ''}
                text={makeUserType(t)}
                onClick={() => handleItemClick(t.key || '')}
                />
            ))
          :
          null
          }
      </Items>
    </Container>

  ) : null;
};

export default SelectUserType;
